import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const ActivityChart = () => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart if it exists
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      // Sample data - this would be fetched from the contract in a real application
      const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        datasets: [
          {
            label: 'Investments',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: 'rgba(0, 255, 170, 0.2)',
            borderColor: 'rgba(0, 255, 170, 1)',
            borderWidth: 2,
            tension: 0.4
          },
          {
            label: 'Rewards',
            data: [7, 11, 5, 8, 3, 7],
            backgroundColor: 'rgba(123, 77, 255, 0.2)',
            borderColor: 'rgba(123, 77, 255, 1)',
            borderWidth: 2,
            tension: 0.4
          }
        ]
      };

      // Chart options
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(255, 255, 255, 0.1)'
            },
            ticks: {
              color: 'rgba(255, 255, 255, 0.7)'
            }
          },
          x: {
            grid: {
              color: 'rgba(255, 255, 255, 0.1)'
            },
            ticks: {
              color: 'rgba(255, 255, 255, 0.7)'
            }
          }
        },
        plugins: {
          legend: {
            labels: {
              color: 'rgba(255, 255, 255, 0.7)'
            }
          }
        }
      };

      // Create new chart
      const ctx = chartRef.current.getContext('2d');
      chartInstance.current = new Chart(ctx, {
        type: 'line',
        data: data,
        options: options
      });
    }

    // Cleanup function
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  return (
    <div className="chart-container">
      <h2>Activity Analytics</h2>
      <canvas ref={chartRef}></canvas>
    </div>
  );
};

export default ActivityChart;
